
<image-container-card
  v-bind="$attrs"
  v-on="$listeners"
  :image="item.thumbnail || item.image"
>
  <align justify="space-between">
    <div class="platform-text">
      <span>{{ item.platform }}</span><span v-if="item.seller"> - {{ item.seller }}</span>
    </div>
  </align>

  <div class="item-text">{{ item.title }}</div>

  <align direction="flex-end" justify="space-between">
    <align small-gap>
      <card-stat-item
        :card="item"
        stat="price"
      />

      <verified-icon v-if="verified" />
    </align>


    <div class="extra-info">
      <span>{{ item.listingType }}</span>
      <span>{{ $filters.date(item.date) }}</span>
    </div>
  </align>
</image-container-card>
